<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="condicao" class="px-1" fab icon x-small v-bind="attrs" :disabled="disabled" v-on="on" @click="$emit('click')">
        <v-icon small>
          {{ item.icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ item.nome }}</span>
  </v-tooltip>
</template>
<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => {}
      },

      condicao: {
        type: Boolean,
        default: true
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    emits: ['click']
  };
</script>